import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  selectIsLoggedIn,
  selectUser,
} from "../redux/features/auth/AuthSlice";

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const user = useSelector(selectUser);

  if (!isLoggedIn) {
    return children;
  }

  const redirectPath =
    user?.role === "admin"
      ? "/items"
      : "/tableNo";

  return <Navigate to={redirectPath} replace />;
};

export default PublicRoute;